import axios from "axios";
import { capitalize } from "lodash";
import { getPathAPI, getAuthHeaders, triggerBlobDownload } from ".";

export async function downloadExportFile(
  data: Record<string, any>,
  name?: string
): Promise<void> {
  const response = await axios({
    url: `${getPathAPI()}/atlas-files/export`,
    method: "POST",
    responseType: "blob",
    data,
    headers: getAuthHeaders()
  });
  triggerBlobDownload(
    response.data,
    `${name ? name : capitalize(data.type)}.csv`
  );
}
